import React, { useState , useEffect} from "react";
import "./Report.css";
import OrderReports from "./OrderReports";
import { useGetAllEmployeesQuery } from "../auth/employeeSlice";

const Report = () => {
  const [activeTab, setActiveTab] = useState("orders");
  const [employeeData, setEmployeedata] = useState([]);

  const {
    data: employees,
    isLoading,
    isFetching,
    isError,
    error,
  } = useGetAllEmployeesQuery();

  useEffect(() => {
    if (employees) {
      const data = employees.ids.map((id) => {
        return employees.entities[id];
      });
      setEmployeedata(data); 
    }
  }, [employees]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="card report-section p-5">
      <div className="row mb-5">
        <div className="col-6">
          <button
            className={`btn btn-gradient btn-block w-100 p-3 ${
              activeTab === "orders" ? "active" : ""
            }`}
            onClick={() => handleTabClick("orders")}
          >
            Orders
          </button>
        </div>
        {/* <div className="col-6">
          <button
            className={`btn btn-gradient btn-block w-100 p-3 ${
              activeTab === "meetings" ? "active" : ""
            }`}
            onClick={() => handleTabClick("meetings")}
          >
            Meetings
          </button>
        </div> */}
      </div>
      <div className="row">
        <div className="options-section">
          {activeTab === "orders" && <OrderReports employeeData={employeeData} />}
          {activeTab === "meetings" && <div>Meetings content here</div>}
        </div>
      </div>
    </div>
  );
};

export default Report;
